import * as Yup from "yup";
import PaymentGatewayModel from "../../models/masters/paymentgateway-model";
import { API_END_POINT } from "../../constants";
import { InputField } from "../../components/form/input.field.component";
import { FormikModelDialog, SubmitStatus } from "../../core/formik-model-dialog.component";
import { CheckboxField, CheckBoxStyle } from "../../core/checkbox-field.component";
import { useEffect, useState } from "react";
import { useGetDistrict } from "../../apiclient/master/useGetDistrictApi";
import { SelectField } from "../../core/select-field.component";
import { useGetPaymentGateway } from "../../apiclient/master/useGetPaymentGatewayApi";

interface PaymentGatewayEditProps {
  data: PaymentGatewayModel;
  isViewMode?: boolean;
  onClose?: (status: SubmitStatus, data: any) => any;
}


const PaymentGatewayEntry: React.FC<PaymentGatewayEditProps> = ({ ...props }) => {
  let { data, onClose,isViewMode } = props;
  const title = data?.paymentGatewayId > 0 ? "Edit Payment Gateway" : "Add Payment Gateway";

  const [paymentgatewayType, setPaymentGatewayType] = useState<string>("0");
  const paymentgatewayTypes = [
    { value: "1", label: "Milk" },
    { value: "2", label: "Product" }
  ];
  
  
  const handlePaymentGatewayChange = (value: any) => {
    if (value == "1")
    {setPaymentGatewayType("1");}
    else{setPaymentGatewayType("2");}
      };

  let initialValue: PaymentGatewayModel = {
    paymentGatewayId: data?.paymentGatewayId ? data.paymentGatewayId : 0,
    paymentGatewayName: data?.paymentGatewayName ? data.paymentGatewayName : '',
    merchantId: data?.merchantId ? data.merchantId : '',    
    typeId: data?.typeId ? data.typeId.toString() : '',  
    // typeId:paymentgatewayType ? paymentgatewayType : 0,
    gatewayApiKey: data?.gatewayApiKey ? data.gatewayApiKey : '',
    gatewaySecretKey: data?.gatewaySecretKey ? data.gatewaySecretKey : '',
  };
  const validationSchema = Yup.object().shape({
     paymentGatewayName: Yup.string().required("Required"),
    // paymentGatewayName: Yup.string()
    //   .required("Required")
    //   .test("check-duplicate-paymentGatewayName", "PaymentGateway Name already exists", (value) => {
    //     return (
    //       value &&
    //       !existingName.includes(value) ||
    //       (data?.paymentGatewayName && value === data.paymentGatewayName) // Allow current name during update
    //     );
    //   }),


  });

  const [existingName, setExistingName] = useState<string[]>([]);
  const { data: fetchedPaymentGateway } = useGetPaymentGateway();


  useEffect(() => {
    if (fetchedPaymentGateway) {
        setExistingName(fetchedPaymentGateway.map((cat: any) => cat.paymentGatewayName));
    }
  },[fetchedPaymentGateway]);



  return (
    <>
      <FormikModelDialog
        width="50%"
        title={title}
        initialData={initialValue}
        validationSchema={validationSchema}
        show={!!data}
        onClose={onClose}
        endpoint={API_END_POINT.MASTER}
        postRoute="PaymentGateway/SavePaymentGateway"
        showAddAnother={true}
        isViewOnly ={isViewMode}
        isUpDateEntityDetails={data?.paymentGatewayId > 0 ? true : false}
      >
        <div>
          <div className="row">
            <div className="col-6">
              <InputField maxLength={10} label="PaymentGateway *" name="paymentGatewayName" />
            </div>
            <div className="col-6">
              <InputField maxLength={10} label="Merchant ID" name="merchantId" />
            </div>
            <div className="col-6">
              <label>Type </label>
              <SelectField
                name="typeId"
                options={paymentgatewayTypes}
                // unSelectValue=""
                notifyChange={(value: any) => handlePaymentGatewayChange(value)}

              />
            </div>
            <div className="col-6">
              <InputField maxLength={25} label="Gateway Api Key" name="gatewayApiKey" />
            </div>
            <div className="col-6">
              <InputField maxLength={25} label="Gateway Secret Key" name="gatewaySecretKey" />
            </div>




          </div>
        </div>

      </FormikModelDialog>
    </>
  );
};

export default PaymentGatewayEntry;
